export default {
  plural: 'Twin-деталі',
  createButton: 'Створити деталь',
  createTitle: 'Створити деталь',
  editTitle: 'Редагувати деталь',
  deleteTitle: 'Видалити деталь',
  deleteWarning: 'Ви впевнені, що хочете видалити цю деталь?',
  company: 'Компанія'
};
